<template>
  <content-dialog
    v-model="dialogOpen"
    fullscreen-mobile
    no-backdrop-dismiss
    flex
    width="640px"
    height="70vh"
    :title="dialogTitle"
  >
    <TaskStepper
      ref="stepper"
      :mode="mode"
      :loading="loading"
      :used-form-ids="usedFormIds"
      @save="(payload, context) => $emit('save', payload, context)"
      @cancel="close"
    />
  </content-dialog>
</template>

<script>
import TaskStepper from 'components/app/checklists/TaskStepper.vue'

/*
  Thin dialog wrapper around the shared TaskStepper for hosts that aren't
  already a dialog (e.g. the appointment checklist panel). Everything —
  including the report template picker — swaps inside this single dialog.
*/
export default {
  components: {
    TaskStepper
  },
  props: {
    mode: {
      type: String,
      default: 'appointment'
    },
    loading: {
      type: Boolean,
      default: false
    },
    usedFormIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['save'],
  data () {
    return {
      dialogOpen: false,
      editing: false
    }
  },
  computed: {
    dialogTitle () {
      if (this.editing) {
        return 'Edit Task'
      }
      return this.mode === 'template' ? 'Add Checklist Item' : 'Add Task'
    }
  },
  methods: {
    open (item = null, context = null) {
      this.editing = !!item
      this.dialogOpen = true
      this.$nextTick(() => {
        this.$refs.stepper.reset(item, context)
      })
    },
    close () {
      this.dialogOpen = false
    }
  }
}
</script>
